export const uiConst = {
    url: process.env.REACT_APP_URL,
    getUrl: () => uiConst.url,
};




// WEBPACK FOOTER //
// ./src/app/config/Constant.js